import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { getAccount } from '../Hooks/useAccounts';
import { style, iconTheme, position } from '../Hooks/useToast'
import toast, { Toaster } from 'react-hot-toast';
import { UseProvider } from '../Hooks/UseWeb3';
import Connect from './Modal/ConnectModal';
import { backurl } from '../Config/env';


export default function HeaderMenuOptions() {
    const [connect, setConnect] = useState(false)
    const [accountInfo, setAccountInfo] = useState("");

    useEffect(() => {
        setAccountInfo(getAccount());
    }, [])

    const logOut = async () => {
        setAccountInfo("");
        localStorage.removeItem("accountInfo")
        if (localStorage.getItem("walletconnect") != null) {
            const provider = await UseProvider();
            await provider.disconnect()
        }


        toast.success("Wallet Disconnected successfully", {
            position: position.position,
            style: style,
            iconTheme: iconTheme,
        })
        setTimeout(() => {

            window.location.reload()
        }, 1000);
    }
    return (
        <div className='aif-header__menus'>
            {connect && <Connect onDismiss={() => setConnect(false)} />}

            <NavLink to='/launchpad'>Launch X</NavLink>
            <NavLink to='/staking'>AIF earn</NavLink>
            {/* <NavLink to='/ai-compute'>AI Compute</NavLink> */}
            <NavLink to='/storage'>Storage</NavLink>
            <NavLink to='/depin'>DePIN</NavLink>
            <NavLink to='/news'>News</NavLink>
            <NavLink to={`${backurl + '/Images/' + "AInfra_Wp.pdf"}`} >WhitePaper</NavLink>

            {/* <NavLink to='/release'>Release</NavLink> */}

            {(accountInfo == "" || accountInfo == null) ?
                <button className='air-header__button-connect' onClick={() => setConnect(true)}>Connect</button> :
                <button className='air-header__button-connect' onClick={() => logOut()}>{`${accountInfo.substring(0, 5)}...${accountInfo.substring(38, 42)}`}</button>}
            {/* <button className='air-header__button-connect'>Connect Wallet</button> */}
        </div >

    )
}
